import { TypedDocumentNode, gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import LoadingButton from '@sorare/core/src/atoms/buttons/LoadingButton';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import ConfirmDialog from '@sorare/core/src/components/form/ConfirmDialog';
import { FOOTBALL_PLAY_RIVALS_LEAGUES } from '@sorare/core/src/constants/__generated__/routes';

import { messages } from 'components/rivalsUserGroup/Settings/messages';
import { ButtonText } from 'components/rivalsUserGroup/Settings/ui';

import {
  DeleteRivalsUserGroup,
  DeleteRivalsUserGroupVariables,
} from './__generated__/index.graphql';

const DELETE_RIVALS_USER_GROUP_MUTATION = gql`
  mutation DeleteRivalsUserGroup($input: deleteSo5UserGroupInput!) {
    deleteSo5UserGroup(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<DeleteRivalsUserGroup, DeleteRivalsUserGroupVariables>;

export const DeleteLeague = ({ id }: { id: string }) => {
  const [deleteLeague, { loading }] = useMutation(
    DELETE_RIVALS_USER_GROUP_MUTATION
  );
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const navigate = useNavigate();
  return (
    <>
      <LoadingButton
        size="large"
        color="transparent"
        loading={loading}
        fullWidth
        onClick={() => {
          setConfirmDialogOpen(true);
        }}
      >
        <ButtonText color="var(--c-red-600)">
          <FormattedMessage {...messages.deleteLeague} />
        </ButtonText>
      </LoadingButton>
      <ConfirmDialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        onConfirm={async () => {
          await deleteLeague({
            variables: {
              input: { so5UserGroupId: id },
            },
          });
          navigate(FOOTBALL_PLAY_RIVALS_LEAGUES, {
            replace: true,
          });
        }}
        title={
          <HeadlineS>
            <FormattedMessage {...messages.deleteLeague} />
          </HeadlineS>
        }
        message={<FormattedMessage {...messages.deleteLeagueMessage} />}
        ctaProps={{
          color: 'red',
        }}
      />
    </>
  );
};
